module.exports = __webpack_public_path__ + "img/530.8e12ad54.png";